// @core/api/endpoints/workflow/list_prompt_templates.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPromptTemplatesResponse,
} from '../../../types/workflow';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/workflow';

/**
 * List prompt templates
 * Lists prompt templates available in the current scope, builtin seeds included.
 */
export async function ListPromptTemplates(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPromptTemplatesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/prompt-templates`;
  const requestOptions = options;
  return client.get<ListPromptTemplatesResponse>(requestPath, { ...requestOptions, params });
}
